"use client";

import imageHpProfitDescription from "@/assets/images/screens/homepage/profit-description.jpg";
import imageHpProfitDescriptionDesktop from "@/assets/images/screens/homepage/profit-description-desktop@2x.jpg";
import Image from "next/image";
import TextSubHeader from "@/components/typography/TextSubHeader";
import TextHeader from "@/components/typography/TextHeader";
import { ZoomInOnScroll } from "@/components/effects/ZoomInOnScroll";
import DrawHero from "@/screens/homepage/components/drawings/DrawHero";

export default function ProfitDescription() {
  return (
    <ZoomInOnScroll className="relative overflow-hidden">
      <Image
        src={imageHpProfitDescription}
        alt={""}
        className="absolute inset-0 h-full w-full object-cover lg:hidden"
      />
      <Image
        src={imageHpProfitDescriptionDesktop}
        alt={""}
        className="absolute inset-0 hidden h-full w-full object-cover lg:block"
      />
      <div className="m-auto h-[500px] max-w-screen-sm px-5 pt-12 lg:h-[700px] lg:pt-24">
        <div className="relative z-10">
          <TextSubHeader>Kalkulator zysku</TextSubHeader>
          <TextHeader>
            <span className="relative z-10">Sprawdź, ile możesz </span>
            <span className="relative inline-block">
              <span className="relative z-10">zarobić</span>
              <DrawHero className="absolute -inset-x-2 -bottom-0.5" />
            </span>
          </TextHeader>
        </div>
      </div>
    </ZoomInOnScroll>
  );
}
